const ENV_CONFIG = require("./envConfig");
const CommonLibs = require("@tpd-web-common-libs/nodejs-library");
var fs = require("fs");
const oldArkPagesMock = require("./oldArkPagesMock");

// TODO - ADD environment subdomain if missing
const DEPLOY_ENV = {
  PROD: "prod",
  QA: "qa",
  DEV: "dev",
  SIT: "sit",
  HOTFIX: "fix",
  EVODEV: "evo-dev",
  EVOSIT: "evo-sit",
};
// TODO - CAMBIARE ENV_TO_DEPLOY COERENTEMENTE AL DEPLOY NEI VARI AMBIENTI
const ENV_TO_DEPLOY = DEPLOY_ENV.PROD;

function getOldArkEndpoint(pagePath) {
  if (ENV_TO_DEPLOY === DEPLOY_ENV.PROD) {
    return `https://www.unipol.it${CommonLibs.Helpers.EndpointHelper.completePath(
      pagePath
    )}`;
  } else if (ENV_TO_DEPLOY === DEPLOY_ENV.QA) {
    return `https://qa.unipol.it${CommonLibs.Helpers.EndpointHelper.completePath(
      pagePath
    )}`;
  } else if (ENV_TO_DEPLOY === DEPLOY_ENV.HOTFIX) {
    return `https://fix.unipol.it${CommonLibs.Helpers.EndpointHelper.completePath(
      pagePath
    )}`;
  } else {
    // TODO: rebranding 2025 - EVO modificare per rilascio a seconda dell'ambiente
    return CommonLibs.Helpers.EndpointHelper.getHostEndpoint(pagePath)
      .replace("https://dev.unipol.it", "https://svil.unipolsai.it")
      .replace("https://evo-dev.unipolsai.it", "https://svil.unipolsai.it")
      .replace("https://sit.unipol.it", "https://inte.unipolsai.it")
      .replace("https://evo-sit.unipolsai.it", "https://inte.unipolsai.it")
      .replace("https://qa.unipol.it", "https://coll.unipolsai.it")
      .replace("https://fix.unipol.it", "https://axprtpdren.servizi.gr-u.it")
      .replace("https://www.unipol.it", "https://axprtpdren.servizi.gr-u.it")
      .replace("https://unipol.it", "https://axprtpdren.servizi.gr-u.it");
  }
}

async function getPagesTemp(fetchingFromCMSProxy = false) {
  if (fetchingFromCMSProxy) {
    console.log("[DeployManagemet] getPagesTemp is fetchingFromCMSProxy");
    const cmsProxyService = CommonLibs.Providers.CMSProxyService.getInstance();
    return await cmsProxyService.getPages();
  } else {
    console.log("[DeployManagemet] getPagesTemp is NOT fetchingFromCMSProxy");
    return oldArkPagesMock;
  }
}

/**
 * Executes a copy of .proxy-tpd folder under Next public folder, according to: ENV_TO_DEPLOY
 * NOTA: .well-known viene escluso perché servito dinamicamente dall'API route
 */
function enrichNextPublicAssets() {
  if (
    ENV_CONFIG.ENV_NAME != "local_development" &&
    ENV_CONFIG.ENV_NAME != "local_production"
  ) {
    let envToDeploy = ENV_TO_DEPLOY;
    if (ENV_TO_DEPLOY === DEPLOY_ENV.HOTFIX) {
      envToDeploy = DEPLOY_ENV.PROD;
    } else if (ENV_TO_DEPLOY === DEPLOY_ENV.SIT) {
      envToDeploy = DEPLOY_ENV.QA;
    }
    console.log("enrichNextPublicAssets IN PROGRESS");
    fs.cp(
      `./.proxy-tpd/${envToDeploy}`,
      "./public",
      {
        recursive: true,
        // Escludi .well-known per SIT/QA (servito dinamicamente dall'API route)
        // PROD e HOTFIX continuano a servire .well-known da file statici
        filter: (src) => envToDeploy === DEPLOY_ENV.PROD ? true : !src.includes('.well-known')
      },
      (err) => {
        if (err) {
          console.error("enrichNextPublicAssets FAILED", err);
        } else {
          console.log(`enrichNextPublicAssets COMPLETED${envToDeploy !== DEPLOY_ENV.PROD ? ' (excluding .well-known)' : ''}`);
        }
      }
    );
  }
}

function patchNextBatcher() {
  console.error("patchNextBatcher IN PROGRESS");
  try {
    // Copia del file con la modalità specificata
    fs.copyFileSync(`batcher.js`, "./node_modules/next/dist/lib/batcher.js");
    console.log("File copiato con successo");
  } catch (err) {
    console.error("Errore durante la copia del file:", err);
  }
}

function getEnv() {
  return ENV_TO_DEPLOY;
}

module.exports = {
  getOldArkEndpoint,
  getPagesTemp,
  enrichNextPublicAssets,
  patchNextBatcher,
  getEnv,
  ENV_TO_DEPLOY,
  DEPLOY_ENV,
};
